type AddressStreetInfoWithProvinceProps = {
  streetName: string;
  streetNumber: string;
  streetAdditional: string;
  city: string;
  provinceName: string;
  postcode: string;
  countryName: string;
  isReversed: boolean;
  isStreetFieldCombined: boolean;
};

export const AddressStreetInfoWithProvince = ({
  streetName,
  streetNumber,
  streetAdditional,
  city,
  provinceName,
  postcode,
  countryName,
  isReversed,
  isStreetFieldCombined,
}: AddressStreetInfoWithProvinceProps) => {
  const streetInfo = isStreetFieldCombined
    ? [streetName, streetAdditional]
    : isReversed
      ? [streetNumber, streetName, streetAdditional]
      : [streetName, streetNumber, streetAdditional];

  const filterNonEmpty = (fields: string[]) => fields.filter(Boolean).join(", ");

  const firstRow = filterNonEmpty(streetInfo);
  const secondRow = filterNonEmpty([city, provinceName, postcode, countryName]);

  return (
    <>
      <p>{firstRow},</p>
      <p>{secondRow}</p>
    </>
  );
};
